@if (dataSubjects.length > 0) {
    <div>
        <div class="row datasubjects-header">
            <div class="col-6">{{ 'datamanagement.dataStructures.dataSubjectColumnHeader' | transloco }}</div>
            <div class="col-6">{{ 'datamanagement.dataStructures.connectedDataStructuresColumnHeader' | transloco }}</div>
        </div>
        @for (dataSubject of dataSubjects; track dataSubject) {
            <div class="row datasubjects-body">
                <div class="col-6 name">{{ dataSubject.name }}</div>
                <div class="col-6">
                    <button
                        [disabled]="dataSubject.dataStructures.length === 0"
                        class="btn btn-raised btn-block"
                        [class.green]="dataSubject.dataStructures.length > 0"
                        (click)="viewDataStructures(dataSubject)"
                    >
                        @if (dataSubject.dataStructures.length > 0) {
                            <span
                                >{{ 'datamanagement.dataStructures.viewDataStructures' | transloco: { count: dataSubject.dataStructures.length } }}</span
                            >
                        } @else {
                            <span [title]="'datamanagement.dataStructures.manageDataToSelectTitle' | transloco"
                                >{{ 'datamanagement.dataStructures.noDataStructures' | transloco }}</span
                            >
                        }
                    </button>
                </div>
            </div>
        }
    </div>
}
